unit UMainForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ExtCtrls, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Imaging.pngimage, Vcl.Controls, UMainConfig;

type
  TMainForm = class(TForm)
    pnlFooter: TPanel;
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnMenu: TImageControl;
    tmrReset: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure imgLogoClick(Sender: TObject);
    procedure tmrResetTimer(Sender: TObject);
  private
    { Private-Deklarationen }
    FMainConfig: TMainConfig;
    [Async]
    procedure AfterGetConfig(Sender: TObject); async;
    procedure SetMainConfig(const Value: TMainConfig);
    procedure OnTimerReset(sender: TObject);
  public
    { Public-Deklarationen }
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
  protected procedure LoadDFMValues; override; end;

var
  MainForm: TMainForm;

implementation

uses
  ULoginForm, UEssentialHelper, UCommonConfig;

{$R *.dfm}

procedure TMainForm.AfterGetConfig(Sender: TObject);
var frm: TLoginForm;
begin
  ColorComponents(Self,Self.MainConfig.ColorConfig);
  if Self.MainConfig.CommonConfig.AppReset>0 then
    Self.MainConfig.OnTimerReset:=OnTimerReset
  else
    Self.MainConfig.OnTimerReset:=nil;
  frm:=TLoginForm.Create(Self);
  frm.Caption:=Self.Caption;
  frm.Popup:=false;
  await(TLoginForm,frm.Load);
  frm.MainConfig:=Self.MainConfig;
  try
    await(TModalResult,frm.Execute);
  finally
    frm.Free;
  end;
end;

procedure TMainForm.imgLogoClick(Sender: TObject);
begin
  window.open('https://www.delco.de');
end;

procedure TMainForm.OnTimerReset(sender: TObject);
begin
  Self.tmrReset.Enabled:=false;
  if sender is TCommonConfig then begin
    Self.tmrReset.Interval:=(sender as TCommonConfig).AppReset*1000;
    if Self.tmrReset.Interval>0 then
      Self.tmrReset.Enabled:=true;
  end;
end;

procedure TMainForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
end;

procedure TMainForm.tmrResetTimer(Sender: TObject);
begin
  if Self.MainConfig.CurrentForm<>'LoginForm' then
    window.location.reload(false);
end;

procedure TMainForm.WebFormCreate(Sender: TObject);
begin
  Self.MainConfig:=TMainConfig.Create;
  Self.MainConfig.OnPorpertyChanged:=AfterGetConfig;
  Self.MainConfig.GetConfig;
  pnlFooter.Caption:=Self.MainConfig.Copyright;
end;

procedure TMainForm.WebFormResize(Sender: TObject);
begin
  lblHeader.Left:=64;
  lblHeader.Width:=pnlHeader.ClientWidth-btnMenu.Width-imgLogo.Width-32;
  imgLogo.Left:=pnlHeader.ClientWidth-imgLogo.Width-16;
end;

procedure TMainForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlFooter := TPanel.Create(Self);
  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnMenu := TImageControl.Create(Self);
  tmrReset := TTimer.Create(Self);

  pnlFooter.BeforeLoadDFMValues;
  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnMenu.BeforeLoadDFMValues;
  tmrReset.BeforeLoadDFMValues;
  try
    Name := 'MainForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.ChildOrder := 1;
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    SetEvent(imgLogo, Self, 'OnClick', 'imgLogoClick');
    imgLogo.Picture.LoadFromFile('UMainForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnMenu.SetParentComponent(pnlHeader);
    btnMenu.Name := 'btnMenu';
    btnMenu.Left := 8;
    btnMenu.Top := 8;
    btnMenu.Width := 48;
    btnMenu.Height := 48;
    btnMenu.HeightPercent := 100.000000000000000000;
    btnMenu.WidthPercent := 100.000000000000000000;
    btnMenu.ChildOrder := 2;
    btnMenu.Visible := False;
    tmrReset.SetParentComponent(Self);
    tmrReset.Name := 'tmrReset';
    tmrReset.Enabled := False;
    SetEvent(tmrReset, Self, 'OnTimer', 'tmrResetTimer');
    tmrReset.Left := 288;
    tmrReset.Top := 264;
  finally
    pnlFooter.AfterLoadDFMValues;
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnMenu.AfterLoadDFMValues;
    tmrReset.AfterLoadDFMValues;
  end;
end;

end.
